import { Component, OnInit } from '@angular/core';
import { CategoriesListComponent } from '../categories-list/categories-list.component';

@Component({
    selector: 'app-enquiry-page',
    templateUrl: './enquiry-page.component.html',
    styleUrls: ['./enquiry-page.component.scss'],
    standalone: false
})

export class EnquiryPageComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}